<template>
    <div>
        <b-tabs class="emisiones" v-model="tabIndex">
            <template v-if="this.$store.getters.getPermisos == '1'">
            <b-tab>
                 <template slot="title">
                    <h6 class="colorEmision">Percepción</h6>
                    <div class="separador"></div>
                </template>
                <template >
                    <percepcion-emision></percepcion-emision>
                </template>
            </b-tab>
            <b-tab title="P-Emitidas">
                <template >
                    <percepcion-consulta></percepcion-consulta>
                </template>
            </b-tab>
            </template>
            <b-tab active v-if="this.$store.getters.userDataRetencion == '1'">
                 <template slot="title">
                    <h6 class="colorEmision">Retención</h6>
                    <div class="separador"></div>
                </template>
                <template >
                    <retencion-emision></retencion-emision>
                </template>
            </b-tab>
            <b-tab title="R-Emitidas">
                <template >
                    <retencion-consulta></retencion-consulta>
                </template>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
import PercepcionEmision from '@/components/percepcion/PercepcionEmision'
import PercepcionConsulta from '@/components/percepcion/PercepcionConsulta'
import RetencionEmision from '@/components/percepcion/RetencionEmision'
import RetencionConsulta from '@/components/percepcion/RetencionConsulta'
    export default {
        name: 'Percepcion',
        components: {
            PercepcionEmision,
            PercepcionConsulta,
            RetencionEmision,
            RetencionConsulta
        },
        data: () => {
            return {
                tabIndex: 0
            }
        }
    }
</script>

<style lang="scss" scoped>
.colorEmision {
    font-weight: bold;
    color: #00004d;
}
.separador{
    background-color: #ffc12c;
    width: 100%;
    height: 2px
}
</style>